import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CityGatesService } from '@/app/core/services/city-gates/city-gates.service';
import { LoadCityGatesAction, ClearCityGatesAction } from './city-gates.actions';
import { catchError, tap, throwError } from 'rxjs';
import { ICityGateItem } from '@/app/core/interfaces/city-gate.interface';
import { MatDialog } from '@angular/material/dialog';
import { EnovaAlertsComponent } from '@/app/core/utils/enova-alerts/enova-alerts.component';

export interface CityGatesStateModel {
  cityGates: ICityGateItem[];
  loaded: boolean;
}

export const initialState: CityGatesStateModel = {
  cityGates: [],
  loaded: false,
};

@State<CityGatesStateModel>({
  name: 'cityGates',
  defaults: initialState,
})
@Injectable()
export class CityGatesState {
  @Selector() static getCityGates(state: CityGatesStateModel): ICityGateItem[] {
    return state?.cityGates || [];
  }

  @Selector() static isLoaded(state: CityGatesStateModel): boolean {
    return state?.loaded || false;
  }

  /**
   * Busca el UUID de un punto de salida (city gate) por su nombre
   */
  static getCityGateUuidByName(nombre: string) {
    return (state: CityGatesStateModel | any) => {
      const slice = state?.cityGates;
      const cityGates = Array.isArray(slice)
        ? slice
        : Array.isArray(slice?.cityGates)
          ? slice.cityGates
          : [];
      const cityGate = cityGates.find(
        (gate: ICityGateItem) =>
          gate.nombre?.toLowerCase().trim() === nombre?.toLowerCase().trim()
      );
      return cityGate?.uuid || null;
    };
  }

  constructor(
    private cityGatesService: CityGatesService,
    private dialog: MatDialog
  ) {}

  @Action(LoadCityGatesAction)
  LoadCityGatesAction(
    ctx: StateContext<CityGatesStateModel>,
    { filters }: LoadCityGatesAction
  ) {
    return this.cityGatesService.getCityGates(filters).pipe(
      tap(response => {
        ctx.patchState({
          cityGates: response,
          loaded: true,
        });
      }),
      catchError(error => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            text:
              error?.error?.error ||
              error?.details ||
              error?.message ||
              'Ha ocurrido un error al obtener los puntos de salida',
            hiddeCancelBtn: true,
          },
        });
        return throwError(() => error);
      })
    );
  }

  @Action(ClearCityGatesAction)
  ClearCityGatesAction(ctx: StateContext<CityGatesStateModel>) {
    ctx.setState(initialState);
  }
}

